import { FC } from 'react'
import '@ant-design/compatible/assets/index.css'
import { Modal } from 'antd'
import { PaymentMethod } from '@stripe/stripe-js/types/api/payment-methods'

import { StripeElements } from '~/core/StripeElements'
import { IdentityType } from '~/redux-modules/identity/type'
import { AllowedStripePaymentTypes } from '~/core/StripeElements/AllowedStripePaymentTypes'

import { NewPaymentForm } from './NewPaymentForm'

export interface NewPaymentModalProps {
    identity: IdentityType
    visible: boolean
    onClose: () => void
    isLocatedInCheckoutPage?: boolean
    refetchQueries?: any[]
    onPaymentAdded: (setupIntent?: PaymentMethod) => Promise<any>
    allowedPaymentTypes?: AllowedStripePaymentTypes[]
    type: AllowedStripePaymentTypes
}

export const NewPaymentModal: FC<NewPaymentModalProps> = ({
    identity,
    visible,
    onClose,
    isLocatedInCheckoutPage,
    onPaymentAdded,
    allowedPaymentTypes = ['card'],
    type,
}) => {
    let title = 'Add new payment option'

    switch (type) {
        case 'card':
            title = 'Add new credit card'
            break
        case 'us_bank_account':
            title = 'Add new bank account'
    }

    return (
        <Modal
            bodyStyle={{ padding: '12px' }}
            centered
            closable={true}
            title={title}
            footer={null}
            visible={visible}
            onCancel={onClose}
            maskClosable={false}
            width="566px"
        >
            <StripeElements
                userId={identity.id}
                allowedPaymentTypes={allowedPaymentTypes}
            >
                <NewPaymentForm
                    isLocatedInCheckoutPage={isLocatedInCheckoutPage}
                    onPaymentAdded={paymentMethod => {
                        onClose()
                        return onPaymentAdded(paymentMethod)
                    }}
                    type={type}
                />
            </StripeElements>
        </Modal>
    )
}
